const getters = {
  roles: (state) => state.userVUEX.roles,
  permission_routes: (state) => state.permission.routes,
  checkLoginStatus: (state) => state.userVUEX.loggedin,
  landingPage: (state) => state.userVUEX.roleValues,
  getaccess: (state) => state.userVUEX.token,
};

export default getters;
